import './index.erb';
import './index.rb';
import styles from './index.module.scss';

(function () {
  document.addEventListener('DOMContentLoaded', () => {
    const options = {
      rootMargin: '100px',
      threshold: 0
    };

    const callback = entries => {
      const floatingMenu = document.querySelector(
        '#js-floating-sidebar[data-mobile="false"]'
      );

      entries.forEach(entry => {
        floatingMenu.classList.toggle(
          styles['absolute-position'],
          entry.isIntersecting
        );
      });
    };

    const sidebar = $('#js-floating-sidebar');
    const floating = sidebar.attr('data-floating');

    const isFloating = floating === 'true';

    if (isFloating) {
      const observer = new IntersectionObserver(callback, options);
      const footer = document.querySelector('#js-footer');

      observer.observe(footer);
    }
  });
})();
